import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const fetchCuttingMemo = createAsyncThunk('fetchCuttingMemo', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getCuttingMemo`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchNumberingMemo = createAsyncThunk('fetchNumberingMemo', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getNumberingMemo`);
        return response.data;
    } catch (error) {
        throw error;
    }
});
export const fetchNumberingInwMemo = createAsyncThunk('fetchNumberingInwMemo', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getNumberingInwMemo`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchNumInwMemoList = createAsyncThunk('fetchNumInwMemoList', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getNumberingInwMemoList`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchNumberingData = createAsyncThunk('fetchNumberingData', async () => {
    try {
        const response = await axios.get(`${baseUrl}?apicall=getNumberingData`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const InsertNumberingEntry = createAsyncThunk('InsertNumberingEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=insertNumberingEntry`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const InsertNumberingInwardEntry = createAsyncThunk('InsertNumberingInwardEntry', async (postData) => {
    try {
        const response = await axios.post(`${baseUrl}?apicall=insertNumberingInwardEntry`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchNumberingList = createAsyncThunk('fetchNumberingList', async (id) => {
    try {
        const endpoint = id ? `getNumberinglist&numId=${id}` : 'getNumberinglist';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        console.log(response.data)
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchNumberingInwardList = createAsyncThunk('fetchNumberingInwardList', async (id) => {
    try {
        const endpoint = id ? `getNumberingInwardlist&numId=${id}` : 'getNumberingInwardlist';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});

const numberingApi = createSlice({
    name: 'NumberingDatalist',
    initialState: {
        isLoading: false,
        ctInw: null,
        numMemo: null,
        numInwMemo: null,
        numberingInwList: null,
        numberingList: null,
        delreId: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchCuttingMemo.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchCuttingMemo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.ctInw = action.payload;
        });
        builder.addCase(fetchCuttingMemo.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchNumberingMemo.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchNumberingMemo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.numMemo = action.payload;
        });
        builder.addCase(fetchNumberingMemo.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchNumberingData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchNumberingData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.numMemo = action.payload;
        });
        builder.addCase(fetchNumberingData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchNumberingInwMemo.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchNumberingInwMemo.fulfilled, (state, action) => {
            state.isLoading = false;
            state.numInwMemo = action.payload;
        });
        builder.addCase(fetchNumberingInwMemo.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchNumberingList.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchNumberingList.fulfilled, (state, action) => {
            state.isLoading = false;
            state.numberingList = action.payload;
        });
        builder.addCase(fetchNumberingList.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchNumberingInwardList.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchNumberingInwardList.fulfilled, (state, action) => {
            state.isLoading = false;
            state.numberingInwList = action.payload;
        });
        builder.addCase(fetchNumberingInwardList.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });
    }
});

export default numberingApi.reducer;
